import { Paragraph, Box, Heading } from 'grommet'
import styled, { css } from 'styled-components'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'

import { WrapperProps, TextProps } from './types'

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    margin-top: ${theme.newSpaces.xs}px;
    width: 100%;
  `}
`

export const WrapperCard = styled(Box)<WrapperProps>`
  ${({ theme, isRowReverse }) => css`
    flex-direction: ${isRowReverse ? 'row-reverse' : 'row'};
    justify-content: space-between;
    margin-top: ${theme.newSpaces.xs}px;
    max-width: 100%;
    width: 100%;

    ${theme.below.tablet`
      flex-direction: column-reverse;
    `}

    ${theme.below.mobileXL`
      margin-top: ${theme.newSpaces.xs3}px;
    `}
  `}
`

export const Text = styled(Paragraph)<TextProps>`
  text-align: justify;

  ${({ theme, textWidth }) => css`
    ${theme.getTypography('desktop', 'body', 'body2')};

    & > a {
      ${theme.getTypography('desktop', 'body', 'body2')};
    }

    color: ${theme.newColors.darkGray};
    max-width: ${textWidth}px;

    ${theme.below.laptop`
      max-width: 100%;
    `}

    ${theme.below.tablet`
      max-width: 100%;
    `}

    ${theme.below.mobileXL`
     & > a {
      font-weight: ${theme.typography.mobile.body.body2.fontWeight};
      text-align: start;
      font-size: ${theme.typography.mobile.body.body3.fontSize}px;
      line-height: ${theme.typography.mobile.body.body3.lineHeight}px;
     }
      font-weight: ${theme.typography.mobile.body.body2.fontWeight};
      text-align: start;
      font-size: ${theme.typography.mobile.body.body3.fontSize}px;
      line-height: ${theme.typography.mobile.body.body3.lineHeight}px;
    `}
  `}
`

export const CardImage = styled(ImageWithPlaceholder)<WrapperProps>`
  ${({ theme, isRowReverse }) => css`
    margin-left: ${isRowReverse ? '0px' : `${theme.newSpaces.xs}px`};
    margin-right: ${isRowReverse ? `${theme.newSpaces.xs}px` : '0px'};

    ${theme.below.laptop`
      align-self: center;
    `}

    ${theme.below.tablet`
      max-width: 100%;
      height: auto;
      margin: 0px;
    `}

    ${theme.below.mobileXL`
      margin: 23px auto;
    `}
  `}
`

export const TextWrapper = styled(Box)`
  white-space: pre-wrap;
`

export const Title = styled(Heading)`
  width: 100%;

  ${({ theme }) => css`
    color: ${theme.newColors.primary};

    ${theme.below.mobileXL`
      white-space: normal;
      text-transform: none;

      ${theme.getTypography('mobile', 'title', 'title4')};
    `}
  `};
`
